// extracted by mini-css-extract-plugin
module.exports = {"desc":"desc___2L6Wc","sharePanel":"sharePanel___3zGXj","sharePanelTop":"sharePanelTop___35l9J","markdownParagraph":"markdownParagraph___1eE6u"};